<template>
  <app-layout :title="``">
    <template #header>
      <div class="flex w-full justify-between">
        <h2 class="flex items-center md:text-[24px] text-[14px]">{{ title }}</h2>
        <div></div>
      </div>
    </template>

    <div class="mx-auto py-4">Редактор главной</div>
  </app-layout>
</template>

<script setup>
import { defineComponent } from 'vue';
import AppLayout from '@/Layouts/AppLayout.vue';
import JetButton from '@/Jetstream/Button.vue';

const title = 'Editor main page';
</script>
